export enum TabsEnum {
  PRIVATE = 'private',
  PUBLIC = 'public',
  PAYMENT_HISTORY = 'payment-history',
  ANALYTICS = 'analytics',
  EDIT = 'edit',
}
